// extracted by mini-css-extract-plugin
module.exports = {"pintxo-expander-content":"ExpanderContent_pintxo-expander-content___4Txp"};